import { call, put } from 'redux-saga/effects';
import { getPartnerOptinStatus } from 'src/services/UsersService';
import { ACTIVE_SCREEN_KEY, setScreenData } from 'cw-ui-core';

export default function* initializeApp(dispatch, screenKey = ACTIVE_SCREEN_KEY) {
    yield put(setScreenData(['appInitialized'], false, screenKey));
    yield call(getPartnerOptinStatus);
    yield put(setScreenData(['appInitialized'], true, screenKey));
}
